import { useEffect, useRef, useState } from 'react';

const useInterval = (maxNumberOfInterval, period, isProjectSelected) => {
  const numberOfIntervals = useRef(0);
  const [stopPolling, setStopPolling] = useState(false);
  const [isResetInterval, setIsResetInterval] = useState(false);

  const resetInterval = () => {
    numberOfIntervals.current = 0;
    setIsResetInterval(true);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      numberOfIntervals.current += 1;
      if (numberOfIntervals.current >= maxNumberOfInterval) {
        clearInterval(interval);
        setStopPolling(true);
      }
    }, 30000);

    if (isResetInterval) {
      numberOfIntervals.current = 0;
      clearInterval(interval);
      setIsResetInterval(false);
      setStopPolling(false);
    }

    return () => clearInterval(interval);
  }, [maxNumberOfInterval, isProjectSelected, isResetInterval, period]);

  return [stopPolling, resetInterval];
};

export default useInterval;
